import { Component } from '@angular/core';

@Component({
  selector: 'app-document-with-bookmark-icon',
  imports: [],
  templateUrl: './document-with-bookmark-icon.html',
  styleUrl: './document-with-bookmark-icon.scss',
})
export class DocumentWithBookmarkIcon {

}
